import { render } from "./CampaignDetailContent.vue?vue&type=template&id=57a57c39"
import script from "./CampaignDetailContent.vue?vue&type=script&lang=js"
export * from "./CampaignDetailContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__